import { getDatabase, ref, update } from 'firebase/database';
import { getParticipantGroupSessionPath } from './firebasePaths';

export const toggleSessionPausedInFirebase = async (
  sessionId: string,
  isPaused: boolean,
  participantGroupId?: string | number,
) => {
    const database = getDatabase();
    const sessionRef = ref(database, `session_v2/${sessionId}`);
    const updates = [update(sessionRef, { pause: isPaused })];
    if (participantGroupId !== undefined && participantGroupId !== null) {
      const groupSessionRef = ref(
        database,
        getParticipantGroupSessionPath(participantGroupId, sessionId),
      );
      updates.push(update(groupSessionRef, { pause: isPaused }));
    }
    await Promise.all(updates);
};
